import { render, staticRenderFns } from "./admin-footer.vue?vue&type=template&id=f64c3908"
import script from "./admin-footer.vue?vue&type=script&lang=js"
export * from "./admin-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports